<template>
  <!-- body -->
  <div class="body">
    <!-- pooqzone -->
    <div class="pooqzone">
      <!-- intro -->
      <div class="intro">
        <div class="p-dim">
          <!-- contents -->
            <h1 class="pooqzone-hd">
              <img src="../assets/images/wavvezone/logo.png" alt="wavve on logo"/>
            </h1>
            <div class="intro-con">
              <p>
                  <span class="pz-strong">{{ pooqzoneInfo.merchantMessage }}</span>
                  <span>{{ pooqzoneInfo.productMessage1 }}</span>
                  <span>{{ pooqzoneInfo.productMessage2 }}</span>
              </p>
              <button @click="goFreeCategory()">{{ pooqzoneInfo.buttonMessage }}</button>
            </div>
          <!--// contents -->

          <!-- side -->
          <div class="side-bar">
            <div class="pz-pooqtv-box">
                <p>
                  대한민국 대표 앱,<br/>
                  웨이브<br/>
                  아직 이용해보지<br/>
                  않으셨나요?
                </p>
                <div class="side-btn" @click.prevent="pageChange('intro02')">
                  <a href="#">더 알아보기</a>
                </div>
            </div>
            <div class="pz-academy-box">
                <a :href="pooqzoneInfo.BannerLinkUrl" class="pz-academy-link">
                  <img :src="pooqzoneInfo.BannerImageUrl | imgUrl" alt="" aria-describedby="btn-academy">
                  <!-- <img src="http://img.pooq.co.kr/pooqzone/intro/xftjbnjp.bep.png" alt="" aria-describedby="btn-academy"> -->
                    <span id="btn-academy" class="a11y-hidden">
                        <span>아카데미 요금제</span>
                        <p>대학생이라면 5,700원으로 LIVE와 VOD 한달내내 무제한!</p>
                        <span>구매하러가기 링크</span>
                    </span>
                </a>
            </div>
          </div>
          <!--// side -->

          <!-- 기존 서비스 -->
          <div class="in-id">
            <p>이미 웨이브 아이디가 있으신가요?</p>
            <a href="#" @click.prevent="goPooqService()" data-cy="go-wavve">기존 서비스로 보기</a>
          </div>
          <!--// 기존 서비스 -->
        </div>
      </div>
      <!--// intro -->
    </div>
    <!--// pooqzone -->

    <!-- slide -->
    <div class="pooqzone">
      <!-- intro -->
      <div id="intro02" class="intro02">
        <div class="gradation-purple">
          <div class="intro-thumb">
            <strong>TV 그 이상, 대한민국 대표 앱<br />웨이브</strong>
            <button @click.prevent="goPooqService()">웨이브 둘러보기</button>

            <ul>
              <li v-for="dataItem in pooqzoneInfo.list" :key="dataItem.OrderNumber">
                <img :src="dataItem.ImageUrl | imgUrl" :alt="dataItem.Alt"/>
              </li>
              <!--<li>
                <img src="../assets/images/pooqzone/intro-thumb01.jpg" alt=""/>
              </li>
              <li>
                <img src="../assets/images/pooqzone/intro-thumb02.jpg" alt=""/>
              </li>
              <li>
                <img src="../assets/images/pooqzone/intro-thumb03.jpg" alt=""/>
              </li>
              <li>
                <img src="../assets/images/pooqzone/intro-thumb04.jpg" alt=""/>
              </li>
              <li>
                <img src="../assets/images/pooqzone/intro-thumb05.jpg" alt=""/>
              </li>-->
            </ul>
          </div>
        </div>

        <!-- side -->
        <div id="side-b" class="side-b" @click="pageChange('intro01')">
          <div class="s-dim">
            <img src="../assets/images/wavvezone/icon-close.png" alt="icon-close" />
          </div>
        </div>
        <!--// side -->
      </div>
      <!--// intro -->
    </div>
    <!--// slide -->

    <!-- 핀코드 모달 -->
    <pooq-zone-pin-code v-if="showModal"/>
    <!-- 핀코드 모달 -->

  </div>
  <!--// body -->
</template>

<script>
import PooqZonePinCode from '@/components/common/PooqZonePinCode'
import { pooqzoneLoginProc } from '@/common/utils/login'
import { getResultCodeInResponse, getResultMessageInResponse } from '@/common/utils/common'
import constant from '@/common/resources/constant'
import cookie from '@/common/utils/cookie'
import { getPooqzoneCheck } from '@/common/utils/request'
import { removePzInfoOnCookie, removePzOnCookie } from '@/common/utils/pz'
import _ from 'lodash'
import { PATH_NAME_HOME } from '@/common/resources/router.const'
export default {
  components: {
    PooqZonePinCode
  },
  data () {
    return {
      showModal: false,
      // pooqzoneInfo: '',
      pooqzoneInfo: cookie.getPooqZoneTempInfo(),
      referer: '/'
      // agencyname: '',
      // categoryTitle: '',
      // buttonText: '',
      // productimage: '',
      // ImageUrl: ''
    }
  },
  methods: {
    // 방송영화 무료보기
    goFreeCategory () {
      if (this.pooqzoneInfo.pincode === 'y') {
        this.showModal = true
      } else {
        pooqzoneLoginProc({ pincode: 'none' }).then(() => {
          this.$router.replace({ name: PATH_NAME_HOME })
        }).catch((error) => {
          if (getResultCodeInResponse(error.response) === '100') {
            alert(getResultMessageInResponse(error.response))
            this.goPooqService()
          }
        })
      }
    },
    // 기존 Pooq 서비스로 보기
    goPooqService () {
      cookie.removeItems({ keyList: ['pzInfo', 'pz'] })
      cookie.setItem('pz', JSON.stringify({ isPooqzone: false }), false, constant.URL_COOKIE_DOMAIN, '/')
      this.$router.replace(this.referer)
    },
    // 페이지 변경
    pageChange (type) {
      if (type === 'intro02') {
        document.getElementById('intro02').className = 'intro02 pz-intro02-slide'
        document.getElementById('side-b').className = 'side-b'
      } else {
        document.getElementById('intro02').className = 'intro02 pz-intro01-slide'
        document.getElementById('side-b').className = 'side-b'
      }
    }
  },
  created () {
    // 웨이브온 핀코드 닫기
    this.referer = decodeURIComponent(_.get(this.$route, 'query.referer', '/'))
    this.$events.$on('setPinCodePage', value => {
      this.showModal = value
    })
    if (cookie.isWavveOn()) { // 이미 웨이브온
      this.$router.push(this.referer)
    } else if (!this.pooqzoneInfo) { // 웨이브온 인포 없음
      this.goPooqService()
    } else {
      getPooqzoneCheck().then(({ data }) => {
        this.pooqzoneInfo = data
      }).catch((err) => {
        if (_.get(err, ['response', 'data', 'resultcode'], '') === '100') {
          removePzInfoOnCookie()
          removePzOnCookie()
          cookie.setItem('pz', JSON.stringify({ 'isPooqzone': false }), false, constant.URL_COOKIE_DOMAIN, '/')
          location.replace(this.referer)
        }
      })
    }
  },
  beforeDestroy () {
    this.$events.$off('setPinCodePage')
  },
  filters: {
    imgUrl (value) {
      if (!value) return ''
      return `${location.protocol}//${value}`
    }
  }
}
</script>

<style>
  .pz-academy-box img {max-width:100%;}
</style>
<style lang="css" src="@/assets/css/service.css"></style>
